export default {
  TableHead: [
    [
      {
        displayName: 'banner.datatable.number',
      },
      {
        displayName: 'banner.datatable.image',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'banner.datatable.edit',
      },
    ],
  ],
  initialModel() {
    return {
      imagePath: '',
      description: '',
      isActive: true,
    };
  },
};
